import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  declarationId: string;
  notificationId: string;
}

export const useMarkCustomsNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationId, notificationId }: HookProps) => {
      const { data } = await request({
        path: `declarations/${declarationId}/customs-notifications/${notificationId}/read`,
        method: 'PATCH',
        authenticate: true,
      });

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Notification marked read.');
    },
    onError: (error) => {
      showErrorToast(error, `Error marking the notification as read!`);
    },
  });
};
